<lx-selector-field-container
  i18n-label
  label="Course"
  [disabled]="disabled"
  [empty]="!selectedValue"
  [selectorFieldHandler]="openSelectorClickHandler"
  data-qa="courseSelector_field"
>
  {{ selectedValue ? selectedValue.name : emptySelectionMsg }}
</lx-selector-field-container>

<lx-side-panel i18n-title title="Select a course" [visible]="dialogVisible" (hiddenPanel)="hideDialog()" size="large" data-qa="courseSelector_sidePanel">
  <!--  With the *ngIf we re-initialise the tree when we open the selector.
It is a way of forcing to re-paint the whole tree to make sure the selected option is shown as selected.
In the internal state of the tree when we click on selected option, the selection is null. So we have to force the re-paint it to show the selected option again.-->
  <lx-course-selector *ngIf="dialogVisible" [queryReset]="dialogVisible" [autofocus]="dialogVisible" (selectedCourseChanged)="handleSelectedValue($event)">
  </lx-course-selector>
</lx-side-panel>
